import React from 'react'

import Accordion from '../../../../components/Accordion'
import { faqs } from '../../../../constants/anaya-constants'
const Faqs = () => {
  return (
    <div className="pt-10 pb-[60px]">
      <div className="text-[32px] px-[41px] text-[#1F2933] font-[600] leading-[42px]">
        FAQs
      </div>
      <div className="mt-[44px] px-5">
        {faqs?.length > 0 &&
          faqs.map((question, index) => (
            <Accordion
              key={`viemax-faq-${index}`}
              title={question.title}
              answer={question.answer}
              index={index}
              // upIcon={anayaImgUrls.chevronUp}
              // downIcon={anayaImgUrls.chevronDown}
              styles={{
                titleColor: '#242253',
                answerColor: '#667085',
                bg: '#F2F4F7',
              }}
            />
          ))}
      </div>
    </div>
  )
}

export default Faqs
